export const DOMAIN_URL = `https://${window.location.hostname}:3000`;
export const RESTFULL_API_URL = `https://medpro-api-v2-staging.medpro.com.vn:8443/`;
export const STATIC_CONTENT_API_URL = `https://static-inside-testing.medpro.com.vn/static`;
export const COOKIE_EXPIRES = 43200; // 12*60*60; // 12 tiếng

export const SOCKET_CHAT = "wss://alpha-api.medpro.com.vn/cable";
